module.exports = new __parcel__URL__("first_tab_content_ja.56ab0cf7.webp").toString();